import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputTextSF from '../../widgets/form/InputTextSF'
import ButtonLinkUI from '../../widgets/action/ButtonLinkUI'

const PasswordResetStep1UI = ({context, messageList, onSubmit, submitted, successMsg, errorList, setErrorList,
    email, onEmailChange, emailError, setEmailError,
  }) =>
  <React.Fragment>
    <CardUI context={context}>
      <FormSF context={context} messageList={messageList} buttonMessageKey='c_continue'
          onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
          busy={submitted}>
        <InputTextSF type='text' name='email' required={true} maxLength={64}
          messageList={messageList} labelKey='c_email' helpKey='c_tip_password_reset'
          value={email} onChange={onEmailChange}
          error={emailError} setError={setEmailError}
          autoFocus={true}
        />
      </FormSF>
    </CardUI>

    <div className='g_m_top_100'>
      <ButtonLinkUI context={context} messageList={messageList} labelKey='c_passwd_code'
        to={`/pub/password-reset?identity=${email}`}
        transparent={true}
      />
    </div>
  </React.Fragment>

export default PasswordResetStep1UI
